import { CERelationshipAttributePermissionBase } from './ce-relationship-attribute-permission-base'


export class CERelationshipAttributePermission extends CERelationshipAttributePermissionBase {

}